module.exports = __webpack_public_path__ + "img/bank.2fa2ad31.png";